export const BRANCHES_RESET_STATE = 'BRANCHES_RESET_STATE';
export const BRANCHES_CURRENT_ITEM = 'BRANCHES_CURRENT_ITEM';

export const BRANCHES_REQUEST_LOADING = 'BRANCHES_REQUEST_LOADING';
export const BRANCHES_REQUEST_SUCCESS = 'BRANCHES_REQUEST_SUCCESS';
export const BRANCHES_REQUEST_FAILED = 'BRANCHES_REQUEST_FAILED';

export const BRANCHES_CURRENT_ACTION = 'BRANCHES_CURRENT_ACTION';
export const BRANCHES_RESET_ACTION = 'BRANCHES_RESET_ACTION';